module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-animated-calc"
  }, [_c('div', {
    staticClass: "p-animated-calc__container all-cols"
  }, [_c('div', {
    staticClass: "p-animated-calc__column-two--large--cover"
  }), _vm._v(" "), _c('svg', {
    staticClass: "p-animated-calc__logo",
    attrs: {
      "viewBox": "0 0 230.4 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__column-one--small"
  }, [_c('div', {
    staticClass: "p-animated-calc__column-one--small--cover"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/mini-calculators/'
    }
  }, [_c('div', {
    staticClass: "p-animated-calc__top-menu"
  }, [_c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#dashboard"
    }
  })])])]), _vm._v(" "), _vm._t("summary-panel")], 2), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__column-two--large",
    attrs: {
      "id": "print-panel"
    }
  }, [_c('mini-calculator-print'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._t("results-panel")], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid--vertical p-animated-calc__summary-panel"
  }, [_c('div', [_c('h2', {
    staticClass: "prompt"
  }, [_vm._v("\n                        Your Calculation\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Your calculation will appear here once all mandatory fields have been completed.\n                    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64ebb490!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/components/MiniCalculatorPageAlternativeWidth.vue
// module id = 1720
// module chunks = 0